import createReactComponent from '../createReactComponent';
export default createReactComponent('parking', 'IconParking', [
  [
    'path',
    {
      d: 'M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z',
      key: 'svg-0',
    },
  ],
  ['path', { d: 'M9 16v-8h4a2 2 0 0 1 0 4h-4', key: 'svg-1' }],
]);
